import { Pipe, PipeTransform, inject } from "@angular/core";
import { LocalizationService } from "../localization";

@Pipe({
    name: "dateFormat",
    pure: true
})
export class DateFormatPipe implements PipeTransform {
    private localizationService = inject(LocalizationService);


    transform(value: any): string | null {
        if (value == null || value === "" || value !== value) {
            return null;
        }

        if (typeof value === "string") {
            value = new Date(value);
        }

        return this.localizationService.formatDate(
            value,
            this.localizationService.localizationInfo.dateFormat
        );
    }
}
